import { clearPostAuthRedirect, storePostAuthRedirect } from './authRedirect';

export const PENDING_INVITE = 'pendingInvite';
export { POST_AUTH_REDIRECT } from './authRedirect';

export function stashPendingInvite({ token, mode, redirect = '/conversation-type' }) {
  sessionStorage.setItem(PENDING_INVITE, JSON.stringify({ token, mode }));
  storePostAuthRedirect(redirect);
}

export function readPendingInvite() {
  const raw = sessionStorage.getItem(PENDING_INVITE);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    clearPendingInvite();
    return null;
  }
}

export function clearPendingInvite() {
  sessionStorage.removeItem(PENDING_INVITE);
  clearPostAuthRedirect();
}
